import { render, staticRenderFns } from "./DistrictAddress.vue?vue&type=template&id=2f83429e&scoped=true"
import script from "./DistrictAddress.vue?vue&type=script&lang=js"
export * from "./DistrictAddress.vue?vue&type=script&lang=js"
import style0 from "./DistrictAddress.vue?vue&type=style&index=0&id=2f83429e&prod&lang=scss&scoped=true"
import style1 from "./DistrictAddress.vue?vue&type=style&index=1&id=2f83429e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f83429e",
  null
  
)

export default component.exports